import React from 'react';
import { startSteps } from '../data/offer';
export function GetStarted() {
  return <section className="border-t border-white/10 bg-navy-900" data-id="element-84" data-mp="2hnpf3k73rejw">
      <div className="mx-auto w-full max-w-5xl px-4 py-14 sm:px-6 sm:py-16" data-id="element-85" data-mp="2hq25mlqxex8k">
        <h2 className="max-w-xl text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-86" data-mp="2mnk57lj2003w">
          Get Started in Three Simple Steps
        </h2>

        <ol className="mt-8 grid gap-4 sm:grid-cols-3" data-id="element-87" data-mp="1tyn0kl7rm1tm">
          {startSteps.map(step => <li key={step.id} className="border-l-2 border-brand-emerald bg-navy-800 p-5" data-id="element-88" data-mp="1yx80ejj3ujhj">
              <p className="font-pixel text-[10px] uppercase tracking-[0.16em] text-brand-gold" data-id="element-89" data-mp="22y08vak5kkcr">
                {step.index}
              </p>
              <h3 className="mt-2.5 font-pixel text-[11px] uppercase leading-relaxed tracking-[0.08em] text-white" data-id="element-90" data-mp="27rmeiirwfnz2">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-300" data-id="element-91" data-mp="1f85x6wbkl1u3">
                {step.copy}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}